import config from '../config'

export const imageFromServer = (url) => `${config.axios.baseImgUrl}${url}`
